import { useMemo } from "react";
import { useAuth } from "../context/authContext";
import { useOptions } from "../context/optionContext";
import pageRoutes from "../data/pageRoutes";
import { ROUTES } from "../constants";
import { canAccessSettings, filterPageRoutesByAccess } from "../utilities/pageAccess";
import { resolveEnabledAdminModules } from "../utilities/adminModules";

const useAccessiblePages = () => {
	const { hasPermission, user } = useAuth();
	const { optionKeys } = useOptions();
	const enabledAdminModuleSet = useMemo(
		() => new Set(resolveEnabledAdminModules(optionKeys)),
		[optionKeys]
	);

	return useMemo(() => {
		return filterPageRoutesByAccess(pageRoutes, hasPermission, user, enabledAdminModuleSet, optionKeys).map((page) => {
			if (page.href === ROUTES.SETTINGS && canAccessSettings(user)) {
				return {
					...page,
					href: `${ROUTES.ADMIN}?tab=settings`,
				};
			}
			return page;
		});
	}, [enabledAdminModuleSet, hasPermission, user, optionKeys]);
};

export default useAccessiblePages;
